<script setup lang="ts">
import type { ReasonPlace } from "@/components/reasonContext";

import { provideReasonContext } from "@/components/reasonContext";

/**
 * 막힌 이유 자리 문맥을 **슬롯 일부에만** 주는 렌더리스 부품(78차 UXS78-03). 자기 요소를 그리지 않는다.
 * - `PageHero #actions` · `SectionHead #actions` 처럼 한 부품 안에서 버튼 자리만 따로 정하고 싶을 때 쓴다.
 * - 부품 전체가 한 문맥이면 부품 `setup` 에서 `provideReasonContext` 를 바로 부른다.
 */
const props = defineProps<{
  /** 이 슬롯 안 `LoadingButton reasonPlacement="auto"` 의 기본 자리 */
  place: ReasonPlace;
  /**
   * 이 슬롯 안 버튼이 `group` 으로 풀린 막힘 이유를 모아 받는 함수(93차 C93-13 — `AppModal` 바닥 줄이 줄 위 한 줄로 대신 그린다). 주면 `place` 는 `group`.
   * 호출부 화면은 쓰지 않는다.
   */
  collect?: (id: string, text: string | undefined) => void;
}>();

defineSlots<{
  /** 문맥을 받을 내용 */
  default?: () => unknown;
}>();

provideReasonContext({
  get place() {
    return props.place;
  },
  // 수집기를 안 준 호출은 문맥에 `collect` 가 없어야 버튼이 아무것도 알리지 않는다.
  get collect() {
    return props.collect;
  },
});
</script>

<template>
  <slot />
</template>
